module.exports = __webpack_public_path__ + "DancingScript-VariableFont_wght.d3bebba97d549436fd61.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/font/DancingScript-VariableFont_wght.ttf
// module id = ../../../../../src/assets/font/DancingScript-VariableFont_wght.ttf
// module chunks = styles